
/* System defined core library */
import { Component, Input, AfterViewInit, SimpleChanges, OnChanges } from '@angular/core';
// import { MapsAPILoader } from '@agm/core';
import type { IMapMarker, IMapRegion } from '../../models/map.model';
import { MapUtilityService } from '../../services/map-utility.service';
import { BingMapsService } from '../../services/bing-map.service';
import { DefaultLatitude, DefaultLognitude } from '../../../shared/constants/scheduling.constant';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class ProMapComponent implements AfterViewInit, OnChanges {

  // general input options
  @Input() markers: IMapMarker[];
  @Input() zoom: number;
  @Input() latitude: number = DefaultLatitude;
  @Input() longitude: number = DefaultLognitude;
  @Input() region: IMapRegion;
  @Input() isGoogleMapsValid: boolean = true;

  // general options
  useBingMaps: boolean = false;
  zoomDefault: number = 12;
  zoomOnFocus: number = 15;

  // bing options
  isBingMapsLoaded: boolean = false;

  // google options
  isGoogleMapsLoaded: boolean = false;
  // bounds: google.maps.LatLngBounds;
  googleMarkers: IMapMarker[];

  constructor(
    // private mapsAPILoader: MapsAPILoader,
    private bingMapsService: BingMapsService,
    private mapUtilityService: MapUtilityService) {

    this.useBingMaps = this.mapUtilityService.useBingMaps;
    this.zoom = this.zoomDefault;
  }

  /**
   * Make ajax call to load maps after view has been rendered
   * */
  ngAfterViewInit() {
    if (this.useBingMaps) {
      this.bingMapsService.load().then(() => {
        this.isBingMapsLoaded = true;
      });
    } else {
      //this.mapsAPILoader.load().then(() => {
      //    this.isGoogleMapsLoaded = true;
      //    this.redrawGoogleMap();
      //});
    }
  }

  /**
   * Google maps listen on changes
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges) {
    //if (!this.useBingMaps && this.isGoogleMapsLoaded && changes['markers']) {
    //  this.redrawGoogleMap();
    //}
  }

  /**
   * Redraw google maps
   * */
  //private redrawGoogleMap() {
  //  this.googleMarkers = this.markers.slice(0, this.markers.length + 1);
  //  if (this.region) {
  //    this.googleMarkers.push({
  //      latitude: this.region.lat,
  //      longitude: this.region.long
  //    });
  //  }
  //  this.bounds = new google.maps.LatLngBounds();
  //  this.googleMarkers.forEach((marker: IMapMarker) => {
  //    this.bounds.extend(new google.maps.LatLng(marker.latitude, marker.longitude));
  //  });
  //}
}
